// Reusable section header in the editorial luxury style.
export default function SectionHeader({ eyebrow, title, lead, align = "left", number, titleClassName = "text-white" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <div className="flex items-center gap-4 mb-6">
        {number && <span className="number-badge">{number}</span>}
        {eyebrow && <span className="overline">{eyebrow}</span>}
      </div>
      <h2 className={`font-display text-4xl sm:text-5xl ${titleClassName} leading-[1.05] tracking-tight`}>
        {title}
      </h2>
      {lead && (
        <p className="mt-6 text-white/65 text-base sm:text-lg leading-relaxed max-w-2xl">
          {lead}
        </p>
      )}
      <div className="hairline mt-10 max-w-[140px]" />
    </div>
  );
}
